import * as api from "./api";
import { extract } from "./lib";
import { map } from "./lib/walker";

const getSensitive = (all) => all && all.flat().length / all.length > 0.15;

const getSortDetails = (arr) => {
  const occ = {};
  const order = {};

  arr.forEach((subarr, i) => {
    subarr.forEach((_el, j) => {
      const el = `${_el}`.split("-")[0]; // Preserve only the parent category

      occ[el] = (occ[el] || 0) + 1;

      order[el] = order[el] || [i, j];
      order[el][0] = Math.min(i, order[el][0]);
      order[el][1] = Math.min(j, order[el][1]);
    });
  });

  return { occ, order };
};

const getCategories = (arr) => {
  const { occ, order } = getSortDetails(arr);

  return Object.keys(occ).sort((a, b) => {
    if (occ[a] > occ[b]) {
      return -1;
    } else if (occ[a] < occ[b]) {
      return 1;
    }
    if (order[a][1] < order[b][1]) {
      return -1;
    } else if (order[a][1] < order[b][1]) {
      return 1;
    }
    return order[a][0] - order[b][0];
  });
};

const deliver = async (_nodes, expected) => {
  const nodes = Array.isArray(_nodes) ? _nodes : [_nodes];
  const text = nodes.map((n) => map(extract(n), (d) => (d.node as Text).wholeText as any).join(". "));

  let categories = [];
  let isSensitive = false;

  let detailed = {}; // To display in a tabular fashion

  try {
    const { ok, categoriesIAB = [], sensitive = [] } = await api.getCategory(text);

    detailed = { categoriesIAB, sensitive };

    isSensitive = getSensitive(sensitive);
    categories = ok && categoriesIAB.length ? getCategories(categoriesIAB) : categories;

    categories = expected ? [expected, ...categories.filter((k) => k != expected)] : categories;
    categories = categories.slice(0, 2);
  } catch (err) {}

  let ads = [];

  try {
    const requests = await Promise.all(
      categories.map((c) =>
        api
          .getKeywords(c) // { termsQuantity: Math.floor(8 / categories.length) }
          .then(({ statusCode, impressionURL, keywords }) => {
            !statusCode && impressionURL && fetch(impressionURL);
            return keywords || [];
          })
          .catch(() => [])
      )
    );

    ads = requests.flat();
  } catch (err) {}

  return [categories, ads, isSensitive, detailed];
};

window["siteInsight"] = deliver;

export default deliver;
